import {BaseContainerModel} from '../base-container.model';
import { bl_mrp_job_order_generic_doc_link_RowClass } from '../../dbschema/bl_mrp_job_order_generic_doc_link.model';

export class MrpJobOrderGenDocLinkContainerModel extends BaseContainerModel {
  bl_mrp_job_order_generic_doc_link:  bl_mrp_job_order_generic_doc_link_RowClass = new  bl_mrp_job_order_generic_doc_link_RowClass();
}
